import {
  PathwayPageUsageInput,
  UserInterestSurveyTracker,
  VideoUsageInput
} from '@cpd-app/generated';
import { createAction, props } from '@ngrx/store';

export const updateVideoUsage = createAction(
  '[Tracker] Update Video Usage',
  props<{ videoUsage: VideoUsageInput }>()
);

export const saveVideoUsage = createAction('[Tracker] Save Video Usage');

export const saveVideoUsageSuccess = createAction(
  '[Tracker] Save Video Usage Success'
);

export const saveLocalVideoUsage = createAction(
  '[Tracker] Save Local Video Usage'
);

export const saveLocalVideoUsageSuccess = createAction(
  '[Tracker] Save Local Video Usage Success'
);

export const reportDownloaded = createAction('[Tracker] Report Downloaded');
export const reportDownloadedSuccess = createAction(
  '[Tracker] Report Downloaded Success'
);
export const reportShared = createAction('[Tracker] Report Shared');
export const reportSharedSuccess = createAction(
  '[Tracker] Report Shared Success'
);

export const startInterestsTracking = createAction(
  '[Tracker] Start Interests Tracking'
);
export const startInterestsTrackingSuccess = createAction(
  '[Tracker] Start Interests Tracking Success',
  props<{ tracker: UserInterestSurveyTracker }>()
);

export const savePathwayPageUsage = createAction(
  '[Tracker] Save Pathway Page Usage',
  props<{ input: PathwayPageUsageInput }>()
);
export const savePathwayPageUsageSuccess = createAction(
  '[Tracker] Save Pathway Page Usage Success',
  props<{ success: boolean }>()
);
